import React from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import styled from 'styled-components'
import Link from 'components/elements/link'
import { fontWeight } from 'themes/font'
import Clearfix from 'components/elements/clearfix'
import { media } from 'styled-bootstrap-grid'
import PublicUrl from 'components/public-url'

const PersonalizeStyled = styled.div`
  min-height: calc(100vh - 56px);
  padding: 64px 0;
  background-image: url('/img/bg/get-started.svg');
  background-size: cover;
  text-align: center;
  .heading {
    font-size: 32px;
    font-weight: ${fontWeight.bold};
    color: #fff;
  }
`

const ItemStyled = styled.div`
  text-align: center;
  margin-bottom: 32px;
  .icon {
    margin-bottom: 16px;
    img {
      height: 120px;
    }
  }
  .text {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    display: inline-flex;
    border-bottom: 3px solid rgba(255, 255, 255, 0.25);
    padding-bottom: 8px;
  }
  ${media.md`
    margin-bottom: 0;
  `}
`

const Button = styled(Link)`
  display: inline-block;
  background: #fff;
  border-radius: 4px;
  color: #0984e3;
  font-size: 18px;
  padding: 16px 40px;
  text-transform: uppercase;
  font-weight: ${fontWeight.bold} !important;
  border: 0;
`

const Item = ({ icon, text }) => {
  return (
    <ItemStyled>
      <div className='icon'>
        <img src={icon} alt={text} />
      </div>
      <div className='text'>{text}</div>
    </ItemStyled>
  )
}

const Personalize = ({ data: { heading, button, item1, item2, item3, item4 } }) => {
  return (
    <PersonalizeStyled>
      <Container>
        <Row>
          <Col md={6}>
            <Item
              icon={item1.icon.publicURL}
              text={item1.text}
            />
          </Col>
          <Col md={6}>
            <Item
              icon={item2.icon.publicURL}
              text={item2.text}
            />
          </Col>
        </Row>
        <Clearfix height={56} />
        <div className='heading text-center'>{heading}</div>
        <Clearfix height={32} />
        <PublicUrl target='_blank' to={button.link}>
          <Button>{button.text}</Button>
        </PublicUrl>
        <Clearfix height={56} />
        <Row>
          <Col md={6}>
            <Item
              icon={item3.icon.publicURL}
              text={item3.text}
            />
          </Col>
          <Col md={6}>
            <Item
              icon={item4.icon.publicURL}
              text={item4.text}
            />
          </Col>
        </Row>
      </Container>
    </PersonalizeStyled>
  )
}

export default Personalize
